export const paginatorMixin = {
  data() {
    return {
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20, 30, 50, 100, 200, 300, 1000],
    };
  },
  methods: {
    getRequestParams(search, page, pageSize,searchEtype, searchUtype, searchDate, searchDateEnd, anketdel, fileBool) { 
      let params = {};

      if (search) {
        params["search"] = search;
      }

      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }
      if (searchEtype) {
        params["searchEtype"] = searchEtype;
      }
      if (searchUtype) {
        params["searchUtype"] = searchUtype;
      }
      if (searchDate) {
        params["searchDate"] = searchDate;
      }
      if (searchDateEnd) {
        params["searchDateEnd"] = searchDateEnd;
      }
      if (anketdel) {
        params["anketdel"] = anketdel;
      }
      if (fileBool) {
        params["fileBool"] = fileBool;
      }
      return params;
    },
  },
}